module.exports = __webpack_public_path__ + "static/img/search_subcat_item_03_show.4b16e7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_03_show.jpg
// module id = MKLG
// module chunks = 0